export const showListData = [
    {
        label: 'resources.asset.fields.code',
        type: 'textField',
        source: 'code',
    },
];
